module.exports = __webpack_public_path__ + "static/media/sabre.32549ffd.ico";